import {
  CartConditionOptions,
  CartConditionStateType,
  CollectionQuantityDistributorBlockType,
  ProductQuantityDistributorBlockType,
  PurchaseOptions,
  QuantityDistributorBlockType,
  QuantityDistributorType
} from '../types/common/cartConditions'

export const getDefaultQuantityDistributorState = (
  purchaseOption: PurchaseOptions.SPECIFIC_COLLECTIONS | PurchaseOptions.SPECIFIC_PRODUCTS,
  cartCondition: CartConditionOptions.PURCHASE_AMOUNT | CartConditionOptions.PURCHASE_QUANTITY
): QuantityDistributorType => {
  const defaultBlockData: QuantityDistributorBlockType = {
    applicationType: cartCondition,
    minimumValue: cartCondition === CartConditionOptions.PURCHASE_QUANTITY ? 1 : 100,
    maximumEnabled: false,
    maximumValue: cartCondition === CartConditionOptions.PURCHASE_QUANTITY ? 1 : 100,
    catalogueMetadata: []
  }
  if (purchaseOption === PurchaseOptions.SPECIFIC_COLLECTIONS) {
    const collectionBlockData: CollectionQuantityDistributorBlockType = {
      ...defaultBlockData,
      catalogType: purchaseOption,
      collectionIds: []
    }
    return {
      type: purchaseOption,
      quantityDistributionItems: [collectionBlockData]
    }
  }
  const productBlockData: ProductQuantityDistributorBlockType = {
    ...defaultBlockData,
    catalogType: purchaseOption,
    productIds: [],
    variantIds: []
  }
  return {
    type: purchaseOption,
    quantityDistributionItems: [productBlockData]
  }
}

const getQuantityDistributionItems = (quantity_distribution_items: any[], metadata: any[]): QuantityDistributorType => {
  const applicationType =
    quantity_distribution_items[0].price && Boolean(quantity_distribution_items[0].price)
      ? CartConditionOptions.PURCHASE_AMOUNT
      : CartConditionOptions.PURCHASE_QUANTITY
  const catalogType = quantity_distribution_items[0].entities.some((item: any) => item.type === 'COLLECTION')
    ? PurchaseOptions.SPECIFIC_COLLECTIONS
    : PurchaseOptions.SPECIFIC_PRODUCTS

  if (catalogType === PurchaseOptions.SPECIFIC_PRODUCTS) {
    return {
      type: catalogType,
      quantityDistributionItems: quantity_distribution_items.map((item: any, index: number) => {
        return {
          applicationType: applicationType,
          minimumValue: applicationType === CartConditionOptions.PURCHASE_AMOUNT ? item?.price : item?.quantity ?? '',
          maximumEnabled: Boolean(
            applicationType === CartConditionOptions.PURCHASE_AMOUNT ? item?.max_price : item?.max_quantity
          ),
          maximumValue:
            applicationType === CartConditionOptions.PURCHASE_AMOUNT ? item?.max_price : item?.max_quantity ?? '',
          catalogueMetadata: metadata[index],
          catalogType: catalogType,
          productIds: item.entities.find((entity: any) => entity.type === 'PRODUCT')?.entity_id ?? [],
          variantIds: item.entities.find((entity: any) => entity.type === 'VARIANT')?.entity_id ?? []
        }
      })
    }
  }
  return {
    type: catalogType,
    quantityDistributionItems: quantity_distribution_items.map((item: any, index: number) => {
      return {
        applicationType: applicationType,
        minimumValue: applicationType === CartConditionOptions.PURCHASE_AMOUNT ? item?.price : item?.quantity ?? '',
        maximumEnabled: Boolean(
          applicationType === CartConditionOptions.PURCHASE_AMOUNT ? item?.max_price : item?.max_quantity
        ),
        maximumValue:
          applicationType === CartConditionOptions.PURCHASE_AMOUNT ? item?.max_price : item?.max_quantity ?? '',
        catalogueMetadata: metadata[index],
        catalogType: catalogType,
        collectionIds: item.entities.find((entity: any) => entity.type === 'COLLECTION')?.entity_id ?? []
      }
    })
  }
}

export const parseCartConditionsResponse = (
  minimum_quantity?: number | null,
  maximum_quantity?: number | null,
  minimum_amount?: number | null,
  maximum_amount?: number | null,
  quantity_distribution_items?: any[],
  metadata?: any[]
): CartConditionStateType => {
  if (!Boolean(quantity_distribution_items) && !Boolean(minimum_quantity) && !Boolean(minimum_amount)) {
    return {
      type: CartConditionOptions.NO_CONDITIONS
    }
  }
  if (minimum_quantity && Boolean(minimum_quantity)) {
    return {
      type: CartConditionOptions.PURCHASE_QUANTITY,
      selectedOption: {
        type: PurchaseOptions.ENTIRE_CART,
        minimumValue: minimum_quantity,
        maximumEnabled: Boolean(maximum_quantity),
        maximumValue: maximum_quantity ?? ''
      }
    }
  }
  if (minimum_amount && Boolean(minimum_amount)) {
    return {
      type: CartConditionOptions.PURCHASE_AMOUNT,
      selectedOption: {
        type: PurchaseOptions.ENTIRE_CART,
        minimumValue: minimum_amount,
        maximumEnabled: Boolean(maximum_amount),
        maximumValue: maximum_amount ?? ''
      }
    }
  }
  if (quantity_distribution_items && Boolean(quantity_distribution_items?.length)) {
    const applicationType =
      quantity_distribution_items[0].price && Boolean(quantity_distribution_items[0].price)
        ? CartConditionOptions.PURCHASE_AMOUNT
        : CartConditionOptions.PURCHASE_QUANTITY
    const catalogType = quantity_distribution_items[0].entities.some((item: any) => item.type === 'COLLECTION')
      ? PurchaseOptions.SPECIFIC_COLLECTIONS
      : PurchaseOptions.SPECIFIC_PRODUCTS
    return {
      type: applicationType,
      selectedOption: {
        type: catalogType,
        quantityDistribution: getQuantityDistributionItems(quantity_distribution_items, metadata ?? [])
      }
    }
  }
  return {
    type: CartConditionOptions.NO_CONDITIONS
  }
}
